import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { NotificationService } from '@progress/kendo-angular-notification';
import { CustomNotificationComponent } from 'src/app/shared/components/app-custom-notification/app-custom-notification.component';
@Injectable({ providedIn: 'root' })

export class CommonNotificationService {
    constructor(private notificationService: NotificationService,
    ) {

    }
    displayError(message: string) {
        this.notificationService.show({
            content: message,
            cssClass: 'custom-notification',
            hideAfter: 600,
            animation: {
                type: 'fade',
                duration: 1000
            },
            type: { 
                style: 'error', 
                icon: true 
            },
            position: {
                horizontal: 'center',
                vertical: 'top'
            }
        });
    }

    displayInfoMessage(message: string) {
        this.notificationService.show({
            content: message,
            cssClass: 'custom-notification',
            hideAfter: 2000,
            animation: {
                type: 'slide',
                duration: 100
            },
            type: { style: 'info', icon: true },
            position: {
                horizontal: 'center',
                vertical: 'top'
            }
        });
    }

    displaySuccessMessage(message: string) {
        this.notificationService.show({
            content: message,
            cssClass: 'custom-notification',
            hideAfter: 600,
            animation: {
                type: 'slide',
                duration: 500
            },
            type: { style: 'success', icon: true },
            position: {
                horizontal: 'center',
                vertical: 'top'
            }
        });
    }

    displayNotification(isMultipleNotification: boolean = false) {
        isMultipleNotification ? this.notificationService.show({
            content: CustomNotificationComponent,
            cssClass: 'custom-notification',
            animation: { type: 'fade', duration: 1000 },
            type: { style: "success", icon: true },
            position: { horizontal: 'right', vertical: 'bottom' },
            hideAfter: 10000,
            height: 100,
        }) :
        this.notificationService.show({
            content: CustomNotificationComponent,
            animation: { type: 'fade', duration: 1000 },
            type: { style: "success", icon: true },
            position: { horizontal: 'right', vertical: 'bottom' },
            hideAfter: 10000
        });
    }
}